import { useNavigate, useParams } from "react-router-dom";
import Divider from "@mui/material/Divider";
import { Fab, Paper, Skeleton } from "@mui/material";
import { StyledButton } from "../../Components/ui/CustomButton";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Phone,
  Restore,
  Gite,
  Email,
  Edit,
  Public,
  Person,
  Business,
  Numbers,
  Map,
  MapsHomeWork,
  Category,
  Home,
  Opacity,
  LocationCity,
  RequestQuote,
  Flag,
  Assignment,
  OpenInBrowser,
  Tag,
  CreditScore,
  Check,
  Language,
  Inventory,
} from "@mui/icons-material/";
import Navbar from "../../Components/Navbar";
import { useState } from "react";
import { getBranch } from "../../Services/branchService";
import { useEffectAsync } from "../../Hooks/useEffectAsync";
import { IBranch } from "../../@types/branch";

export default function SingleBranchView(): JSX.Element {
  const navigate = useNavigate();
  const { BranchId } = useParams<{ BranchId: string }>();
  const [branch, setBranch] = useState<IBranch>();

  useEffectAsync(async () => {
    if (BranchId) {
      const ID = parseInt(BranchId);
      const response = await getBranch(ID);
      if (response) {
        setBranch(response);
      }
    }
  }, [getBranch]);

  const routePath = () => {
    navigate("/branch-form", { state: { branch } });
  };

  return (
    <div className="paper-content">
      <Navbar />
      {!branch?.branchId ? (
        <Paper elevation={10}>
          <Skeleton
            variant="text"
            sx={{ fontSize: "5rem", margin: 10 }}
            animation="wave"
          />
          <Skeleton
            variant="rounded"
            sx={{ margin: 10, width: "90%" }}
            height={400}
            animation="wave"
          />
        </Paper>
      ) : (
        <>
          <div className="no-padding">
            <h1 className="grid-page-title"> Branch {branch?.branchId} </h1>
          </div>
          <Paper elevation={10} sx={{ padding: 3, mt: 1 }}>
            <Grid2 container spacing={3}>
              <Grid2 xs={12}>
                <em style={{ color: "gray" }}>Branch Information</em>
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Business />
                  Branch Id
                </div>
                {branch.branchId}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Numbers />
                  Code
                </div>
                {branch.brCode}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <LocationCity />
                  District
                </div>
                {branch.district}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Inventory />
                  Product Type
                </div>
                {branch.branchProducts.map((item: any) => (
                  <div key={item.id}>
                    <span>{item.title}</span>
                  </div>
                ))}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Flag />
                  Brand
                </div>
                {branch.brand}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Assignment />
                  Brand Slug
                </div>
                {branch.brandSlug}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <RequestQuote />
                  Max Loan Amount
                </div>
                {branch.maxLoanAmount}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Check />
                  Branch Status
                </div>
                {branch.branchStatus}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <CreditScore />
                  Credit Bureau
                </div>
                {branch.creditBureauType}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Tag />
                  Loan Management System
                </div>
                {branch.loanManagementSystem}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Phone />
                  Phone
                </div>
                {branch.phone}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Email />
                  Email
                </div>
                {branch.branchEmail}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Language />
                  Longitude - Latittude
                </div>
                {branch.longitude} - {branch.latitude}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Public />
                  Time Zone
                </div>
                {branch.timeZone}
              </Grid2>
              <Grid2 xs={6}>
                <div className="grid-title">
                  <Gite />
                  Address
                </div>
                {branch.address1} {branch.city}, {branch.state}, {branch.zip}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Map />
                  Legal Address
                </div>
                {branch.legalAddress}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Home />
                  County
                </div>
                {branch.county}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <MapsHomeWork />
                  Legal Entity Small Loan
                </div>
                {branch.legalEntitySmallLoan}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <MapsHomeWork />
                  Legal Entity Large Loan
                </div>
                {branch.legalEntityLargeLoan}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <MapsHomeWork />
                  Legal Product
                </div>
                {branch.legalProductType}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Category />
                  Operating Type
                </div>
                {branch.branchOperatingType}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Tag />
                  Underwriting Type
                </div>
                {branch.underwritingType}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Restore />
                  Hours
                </div>
                {branch.hours}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Opacity />
                  Density Type
                </div>
                {branch.densityType}
              </Grid2>
              <Grid2 xs={6}>
                <div className="grid-title">
                  <OpenInBrowser />
                  Webpage
                </div>
                {branch.webPage}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Check />
                  Has Access To Find a Branch
                </div>
                {branch.hasAccessToFindABranch ? "True" : "False"}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Check />
                  Central Sales Branch
                </div>
                {branch.isCentralSales ? "True" : "False"}
              </Grid2>
            </Grid2>
            <Divider sx={{ margin: "2%" }} />
            <Grid2 container spacing={6}>
              <Grid2 xs={10}>
                <em style={{ color: "gray" }}>Manager Information</em>
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Person />
                  Manager Name
                </div>
                {branch.manager}
              </Grid2>
              <Grid2 xs={3}>
                <div className="grid-title">
                  <Email />
                  Manager Email
                </div>
                {branch.mgrEmail}
              </Grid2>
              <Grid2 xs={6}>
                <div className="button-toolbar">
                  <StyledButton
                    type="button"
                    style={{ marginBottom: 5, marginRight: 25, marginTop: 5 }}
                    onClick={() => navigate("/branch-table")}
                  >
                    Cancel
                  </StyledButton>
                  <Fab color="primary" onClick={routePath}>
                    <Edit />
                  </Fab>
                </div>
              </Grid2>
            </Grid2>
          </Paper>
        </>
      )}
    </div>
  );
}
